import { useEffect } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import Error from "./myComponents/error";
import Home from "./myComponents/home";
function App() {
  useEffect(() => {
    const domain = window.location.hostname;
    let faviconPath = '/favicon.ico';

    if (domain.includes('.ibchotels.')) {
      faviconPath = '/favicon-ibc.png';
    }

    const setFavicon = (url) => {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = url;
    };

    setFavicon(faviconPath);
  }, []);
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/:p_id" element={<Home />} />
          <Route exact path="/error" element={<Error />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
